






import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import BankAccountList from '@/components/bankAccount/BankAccountList.vue';
import { BankAccount, MangoPayMandates } from '@/store/mangoPay/types';

@Component({
  name: 'bank-list-view',
  components: {
    BankAccountList,
  },
})
export default class BankListView extends Vue {
  @Getter('mangoPay/bankAccounts') bankAccounts?: Array<BankAccount>;
  @Getter('mangoPay/mandates') mandates: MangoPayMandates;
}
